import bwipjs from 'bwip-js';

export default class Account {
  constructor() {
    this.event = 'change';
    this.$select = $('.store-list-selector');
    this.$fidelityCardFlagActivator = $('#fidelitycard-consent-activator');
    this.$fidelityCardButtonActivator = $('#fidelitycard-button-activator');
    this.$cardNumber = $('#card-redeem-number');
    this.$cardRedeemPoints = $('#card-redeem-points-total');
    this.$modalLabelPoints = $('#redeem-points-confirm-label');
    this.$redeemCouponConfirm = $('#btn-redeem-coupon-confirm');
    this.$redeemModal = $('#redeem-modal');
    this.$copyToClipboard = '#copy-to-clipboard';
  }

  init() {
    this.getCardRedeemPoints();
    this.handlerPreferredStore();
    this.handlerFidelityCardActivator();
    this.handlerFidelityCardTransaction();
    this.handlerEAN();
    this.handlerRedeemCouponModal();
    this.handlerNotify();
    this.handleAdyenSavePayment();
    this.addFidelityConventionCode();
    this.refreshFidelityCard();
  }

  getCardRedeemPoints() {
    if (this.$cardNumber.length > 0 || this.$cardRedeemPoints.length > 0) {
      this.$cardRedeemPoints.text('').spinner().start();

      $.ajax({
        url: this.$cardRedeemPoints.attr('data-url-load-points'),
        type: 'GET',
        data: {},
        success: (data) => {
          this.$cardRedeemPoints.text(!data.error ? data.points : data.msg).addClass(data.error ? 'failed' : '');

          if (!data.error) {
            this.handlerRedeemPoints(data.points);
          }
        },
        error: () => {
          this.$cardRedeemPoints.text(this.$cardRedeemPoints.attr('data-unsuccess-msg')).addClass('failed');
        }
      });
    }
  }

  handlerPreferredStore() {
    this.$select.on(this.event, (e) => {
      const $selected = $(e.target.selectedOptions);
      const name = $selected.text().trim();
      const storeId = $selected.val();
      const url = $selected.attr('data-url');

      if (!url) return;
      $.spinner().start();
      $.ajax({
        url: url,
        type: 'GET',
        data: jQuery.param({ name: name, storeId: storeId }),
        success: (data) => {
          $.spinner().stop();
          if ($('.action-store-locator').length > 0) {
            $('.action-store-locator').attr('href', data.urlStore);
            $('.action-store-locator').find('.name').text('');
            $('.action-store-locator').find('.name').text(data.store);
          }

          if ($('.add-to-preferred-store-messages').length === 0) {
            $('body').append('<div class="add-to-preferred-store-messages my-account-fancy-notify"></div>');
          } else {
            $('.add-to-preferred-store-messages').empty();
          }

          $('.add-to-preferred-store-messages').append(
            `<div class="alert${
              data.success ? '-success' : '-danger'
            } my-account-fancy-notify-alert add-to-preferred-store-alert text-center" role="alert">${data.msg}</div>`
          );

          setTimeout(() => {
            $('.add-preferred-store-alert').remove();
          }, 2000);
        },
        error: () => {
          $.spinner().stop();
        }
      });
    });
  }

  handlerFidelityCardActivator() {
    this.$fidelityCardFlagActivator.on('change', (e) => {
      this.$fidelityCardButtonActivator.attr('disabled', !$(e.currentTarget).is(':checked'));
    });
  }

  handlerFidelityCardTransaction() {
    this.$fidelityCardButtonActivator.on('click', (e) => {
      const url = $(e.currentTarget).attr('data-activation-url');
      const checked = this.$fidelityCardFlagActivator.is(':checked');

      this.$fidelityCardButtonActivator.spinner().start();
      $.ajax({
        url: url,
        type: 'GET',
        data: jQuery.param({ flag: checked }),
        success: (data) => {
          this.$fidelityCardButtonActivator.spinner().stop();
          if (!data.error) {
            setTimeout(() => window.location.reload(), 700);
          } else {
            this.$fidelityCardFlagActivator.remove();
            this.$fidelityCardButtonActivator.attr('disabled', true);
            $('[for="fidelitycard-consent-activator"]').text(data.msg);
          }
        },
        error: () => {
          window.location.reload();
        }
      });
    });
  }

  handlerEAN() {
    const canvas = document.createElement('canvas');
    const $image = $('#image-ean-redeem');
    const options = {
      bcid: 'ean13',
      text: $image.attr('data-redeem-ean-code'),
      scale: 3,
      height: 15,
      includetext: true,
      textxalign: 'center'
    };

    try {
      bwipjs.toCanvas(canvas, options);
      $image.attr('src', canvas.toDataURL('image/png'));
    } catch (e) {
      $('#image-ean-redeem-render').text(e);
    }
  }

  handlerRedeemPoints(points) {
    $('.card-redeem .circle-chart-render')
      .each((index, elem) => {
        const $this = $(elem);
        const pointsGiven = parseFloat(points);
        const staticPoints = parseFloat($this.attr('data-points'));
        const percentage = ((pointsGiven / staticPoints) * 100).toFixed(1);

        $this
          .addClass(`${pointsGiven >= staticPoints ? 'active' : 'disabled'} animation`)
          .attr('data-target', pointsGiven >= staticPoints ? '#redeem-modal' : '')
          .find('.circle-chart-circle')
          .removeClass(pointsGiven !== 0 ? 'd-none' : '')
          .attr('stroke-dasharray', parseFloat(percentage) > 100 ? '100,100' : `${percentage},100`);
      })
      .on('click', (e) => {
        const $this = $(e.currentTarget);
        if ($this.hasClass('active')) {
          // data-points is only used to show the label: the server resolves points and discount from the tier
          this.$modalLabelPoints.text($this.attr('data-points'));
          this.$redeemCouponConfirm.attr('data-tier', $this.attr('data-tier'));
        }
      });
  }

  handlerRedeemCouponModal() {
    this.$redeemCouponConfirm.on('click', (e) => {
      const $this = $(e.currentTarget);
      const url = $this.attr('data-reedem-coupon-integration-url');
      const body = { tier: $this.attr('data-tier') };
      body[$this.attr('data-csrf-name')] = $this.attr('data-csrf-token');
      const isCartPage = $('.cart-wrapper').length > 0;
      const callback = ($this, data) => {
        $this.spinner().stop();
        $this.attr('disabled', false);
        this.$redeemModal.modal('hide');

        if ($('.redeem-coupon-messages').length === 0) {
          $('body').append('<div class="redeem-coupon-messages my-account-fancy-notify"></div>');
        } else {
          $('.redeem-coupon-messages').empty();
        }

        const copyToClipboard = `<div class="d-flex align-items-center justify-content-center mt-3">
            <span class="coupon mr-4"><strong><u id="coupon-id">${data.couponID}</u></strong></span>
            <button
              type="button"
              id="${this.$copyToClipboard.replace('#', '')}"
              class="copy-to-clipboard btn border-0 p-0"
              data-toggle="tooltip"
              data-placement="top"
              title="${data.copyText}"
              data-init-title="${data.copyText}"
              data-msg-copied="${data.copiedText}">
              <svg role="img" class="copy-to-clipboard-svg-icon">
                <use xlink:href="${data.iconURL}"></use>
              </svg>
            </button>
          </div>`;

        const domString = `<div class="alert${
          !data.error ? '-success' : '-danger'
        } my-account-fancy-notify-alert alert-dismissible fade show redeem-coupon-messages-alert text-center" role="alert">
            <button type="button" class="btn btn-close border-0 p-0" data-dismiss="alert"><span aria-hidden="true">&times;</span></button>
            <p class="m-0">${isCartPage ? data.cartMsg : data.msg}</p>
            ${!data.error && !isCartPage ? copyToClipboard : ''}
          </div>`;

        $('.redeem-coupon-messages').append(domString);

        if (isCartPage > 0 && !data.error) {
          $('#couponCode').val(data.couponID);
          $('.promo-code-btn').trigger('click');
        } else {
          setTimeout(() => $(this.$copyToClipboard).tooltip('show'), 700);
        }
      };

      $this.spinner().start();
      $this.attr('disabled', true);
      $.ajax({
        url: url,
        type: 'POST',
        data: body,
        success: (data) => {
          callback($this, data);
        },
        error: () => {
          const data = { error: true, msg: $this.attr('data-unsuccess-msg') };
          callback($this, data);
        }
      });
    });
  }

  handlerNotify() {
    $(document).on('click', '.redeem-coupon-messages .btn-close', (e) => {
      const $this = $(e.currentTarget);
      $this
        .parent()
        .addClass('fade-out')
        .on('animationend', () => {
          $this.parent().remove();
        });
      if ($this.parent().hasClass('alert-success')) this.getCardRedeemPoints();
    });

    const refreshTooltip = () => {
      $(this.$copyToClipboard).on('hidden.bs.tooltip', () => {
        const text = $(this.$copyToClipboard).attr('data-init-title');
        if ($(this.$copyToClipboard).hasClass('copied')) {
          $(this.$copyToClipboard)
            .removeClass('copied')
            .attr('title', $(this.$copyToClipboard).attr('data-init-title'))
            .attr('data-original-title', text)
            .tooltip('update');
        }
      });
    };

    $(document).on('click', this.$copyToClipboard, () => {
      navigator.clipboard.writeText($('#coupon-id').text()).then(
        () => {
          const text = $(this.$copyToClipboard).attr('data-msg-copied');
          $(this.$copyToClipboard)
            .addClass('copied')
            .attr('title', text)
            .attr('data-original-title', text)
            .tooltip('update')
            .tooltip('show');
          refreshTooltip();
        },
        (err) => {
          $(this.$copyToClipboard).attr('title', err).attr('data-original-title', err).tooltip('update').tooltip('show');
          refreshTooltip();
        }
      );
    });
  }

  handleAdyenSavePayment() {
    $(document).on('click', 'button[value="add-new-payment"]', () => {
      if ($('.adyen-fields').attr('data-sid') === 'true') {
        const lastDigits = $('#cardNumber').val().replace(/\*/g, '');
        const url = new URL(window.redirectUrl);

        url.searchParams.set('lastDigits', lastDigits);
        window.redirectUrl = url.href;
      }
    });
  }

  addFidelityConventionCode() {
    $(document).on('submit', 'form.addFidelityConventionCodeForm', function (e) {
      e.preventDefault();
      const $form = $(this);
      const idtFidelityConventionCode = $form.find('input#fidelity-idtFidelityConventionCode').val();
      const customerNo = $form.find('input[name=customerNo]').val();

      $.spinner().start();

      $.ajax({
        url: $form.attr('action'),
        type: 'POST',
        data: {
          idtFidelityConventionCode,
          customerNo
        },
        success: function (data) {
          $.spinner().stop();
          if (data.error === false) {
            window.location.reload();
          }
        },
        error: function () {
          $.spinner().stop();
        }
      });
    });
  }

  refreshFidelityCard() {
    $(document).on('click', 'a.refresh-fidelityCard', () => {
      window.location.reload();
    });
  }
}
